export default __webpack_public_path__ + "static/media/LinkedIn-Learning Programming Foundation (python).97f0d3e8.webp";